<ui-card
  *ngIf="product"
  [selected]="selected"
  [ngClass]="{ selectable: selectable }"
  (click)="onClick()"
>
  <ui-card-header>
    <ui-card-title *ngIf="product.title">{{ product.title }}</ui-card-title>
    <ui-card-radio
      [selected]="selected"
      (valueChange)="isSelected()"
    ></ui-card-radio>
  </ui-card-header>
  <ui-card-body>
    <div class="price-container">
      <div class="monthPrice">
        £{{ product.perMonthPrice | number: '1.2-2' }} per Month
      </div>
      <div class="yearlyPrice">
        12 Months for £{{ product.yearlyPrice | number: '1.2-2' }}
      </div>
    </div>
    <div *ngIf="product.extraCost" class="extraCost">
      + £{{ product.extraCost | number: '1.2-2' }} per Month
    </div>
    <div class="desc" *ngIf="product.desc">{{ product.desc }}</div>
  </ui-card-body>
</ui-card>
